module.exports = __webpack_public_path__ + "static/media/popup-background.9f87a55e.png";